import Chart from './ChartComponent';
import SetupHelp from './TagsSetupHelpComponent';

export default {
  Chart,
  SetupHelp
};



// WEBPACK FOOTER //
// ./src/components/aws/tags/index.js